












































import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import IntegrationTableBody from '@/components/tc-toble-body/Integration.ts'
import IntegrationForm from '@/views/settings/components/IntegrationForm.ts.vue'
import SalesForceIntegrationForm from '@/views/settings/components/SalesForceIntegrationForm.vue'
import APIIntegrationForm from "@/views/settings/components/APIIntegrationForm.vue";
import { mapState } from 'vuex';

const VisitManagement = namespace('visitManagement');

export interface Integration {
  id: number;
  name: string;
  integrationType: string;
  description: string;
  logoUrl: string;
}
@Component(
  {
    computed: {
    ...mapState('visitManagement', {
      tenantIntegrations: (state : any) => state.tenantIntegrations,
      integrations: (state : any) => state.integrations.items
    })
    },
  }
)
export default class SettingIntegration extends Vue {
  private tbody: unknown = {
    component: IntegrationTableBody
  }

  private newIntegrationPrompt: boolean = false

  @VisitManagement.Action('getIntegration')
  private getIntegration!: (id: number) => Promise<{config: unknown, integration: Integration}>;

  public async newIntegration(): Promise<void> {
    await this.$store.dispatch('visitManagement/fetchIntegrations', {});
    this.newIntegrationPrompt = true;
  }

  private async created(): Promise<void> {
    //this.tenantIntegrations = await this.$store.dispatch('visitManagement/fetchTenantIntegrations', {});
  }

  private async filter(): Promise<void> {
    await this.$store.dispatch('visitManagement/fetchTenantIntegrations', {});
  }

  // Callback after a delete is processed
  public deleted (id : any): void {
    (this.$refs.table as any).invokeFilter();
  }

  public async selected (item: Integration) { } // needed to eliminate the error this.$parent.clicktr

  public onAddIntegration (item: any): void {
    this.$root.$tcPopup.show({
      data: {
        "integration": {
            "id": item.id,
            "name": item.name,
            "integrationType": item.integrationType,
            "description": item.description,
            "logoUrl": item.logoUrl
        },
        "config": item.config ? JSON.stringify({...JSON.parse(item.config), locations: {}}) : "",
      },
      classes: 'vs-dialog--md',
      title: 'New Integration',
      component: this.getComponent(item.integrationType),
    })
  }

  private getComponent (integrationType: string): any {
    let form: any = null;
    switch(integrationType) {
      case "AzureAD":
        form = IntegrationForm;
        break;
      case "Salesforce":
        form = SalesForceIntegrationForm;
        break;
      case "API":
        form = APIIntegrationForm;
        break;
    }

    return form;
  }
}
